import {Injectable} from '@angular/core';
import {LocalStorageHelpers} from './localStorageHelpers';
import {FacebookService, InitParams} from 'ngx-facebook';

@Injectable()
export class ProfileHelpers {

  constructor(private localStorageHelpers: LocalStorageHelpers, private fb: FacebookService) {

  }


  getUserData(): Object {
    // create authorization header with jwt token
    const currentUserData = this.localStorageHelpers.get('userData');
    if (currentUserData) {
      return JSON.parse(currentUserData);
    }
  }

  getUserName(): any {
    const userData: Object = this.getUserData();
    return userData['name'];
  }

  getUserFacebookImage(user_id){

    const initParams: InitParams = {
      appId: '343090895841828',
      xfbml: true,
      version: 'v2.8'
    };

    this.fb.init(initParams);

    return this.fb.api('/' + user_id + '/picture/?type=normal')
      .then(res => {
        return res['data']['url'];
      })
      .catch(e => {
        // console.error(e);
      });
  }


}
